<template>
  <div>
    <!-- Search key -->
    <b-form-group label="Campo de busca" label-for="input-search-key">
      <b-form-select
        :options="optionsSearchKey"
        v-model="formSearchKeyField.value"
        v-on:change="fieldSearchKeyChange($event)"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['SearchKey']">
        {{ modelstate["SearchKey"][0] }}
      </span>
      <!-- <p>formSearchKeyFieldValue: {{ formSearchKeyFieldValue }}</p> -->
      <!-- <p>formSearchKeyField: {{ formSearchKeyField }}</p> -->
      <!-- {{ form }} -->
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "FormSearchKey",
  props: {
    form: null,
    modelstate: null,
  },
  data() {
    return {
      formSearchKeyField: null,
    };
  },
  computed: {
    optionsSearchKey() {

      // Get all active fields to apply on a searchKey select component
      var searchKeys = [];
      if (this.form) {
        if (this.form.campos) {
          this.form.campos.filter((campo) => campo.nome != "" && campo.ativo).forEach((campo) => {
            searchKeys.push({
              value: campo.sequenciaExibicao,
              text: campo.nome,
              field: campo,
            });
          });
        }
      }

      // Define default searchKey if this information is null
      if (!this.formSearchKeyField) {
        if (searchKeys.length > 0) {
          let fieldsFiltred = searchKeys.filter((x) => x.field.searchKey == true);
          if (fieldsFiltred.length > 0) {
              this.formSearchKeyField = fieldsFiltred[0];
              this.formSearchKeyField.field.searchKey = true;
          } else {
              this.formSearchKeyField = searchKeys[0];
              this.formSearchKeyField.field.searchKey = true;
          }
        }
      }

      return searchKeys;
    },
  },
  methods: {
    fieldSearchKeyChange(e) {
      if (this.form) {
          if (this.form.campos) {
              this.form.campos.forEach((campo) => {
                campo.searchKey = false;
              });

              let fieldsFiltred = this.optionsSearchKey.filter(x => x.value == e);
              if (fieldsFiltred.length > 0) {
                  this.formSearchKeyField = fieldsFiltred[0];
                  if (this.formSearchKeyField) {
                      this.formSearchKeyField.field.searchKey = true;
                  }
              }
          }
      }
    },
  },
  //   watch: {
  //       form() {

  //       }
  //   }
};
</script>
